// extracted by mini-css-extract-plugin
export default {"OfferListSection":"OfferListSection_OfferListSection__cDTK7","OfferListSectionTitle":"OfferListSection_OfferListSectionTitle__dKLJl","Spin":"OfferListSection_Spin__q5z1m"};